export var token = function token(name) {
  return function (_ref) {
    var theme = _ref.theme;

    if (theme) {
      var currentTheme = theme.armor || theme;
      var prefixedTokenName = "$".concat(name);

      if (prefixedTokenName in currentTheme.referenceIndex) {
        return currentTheme.referenceIndex[prefixedTokenName];
      }

      return name;
    }

    return name;
  };
};